import { parse } from 'date-fns';

export function parseDateToApi(date: string, time = '', format = 'yyyy-MM-dd HH:mm') {
  const input = `${date} ${time}`.trim();

  return parse(input, format, new Date());
}
